import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Button,
} from "@mui/material";

const CTA = () => {
  return (
    <Box component="section" sx={{ my: 10, px: { xs: 2, sm: 4 } }}>
      <Paper
        elevation={12}
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: 4,
          bgcolor: "rgba(15,23,42,0.9)",
          border: "1px solid rgba(148,163,184,0.25)",
          backdropFilter: "blur(6px)",
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={4}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
        >
          {/* Copy */}
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 900,
                color: "#fff",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Get in contact today!
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mt: 1.5,
                maxWidth: 500,
                color: "rgba(226,232,240,0.8)",
              }}
            >
              Everything you need to bring your station into compliance and get
              the information you need — fully automated.
            </Typography>
          </Box>

          {/* CTA Button */}
          <Button
            variant="contained"
            color="primary"
            size="large"
            href="#contact"
            sx={{
              fontWeight: 900,
              px: 4,
              py: 1.5,
              borderRadius: 3,
              whiteSpace: "nowrap",
              boxShadow: "0 10px 40px rgba(59,130,246,0.4)",
            }}
          >
            Contact Sales
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CTA;
